import React from 'react';

interface SectionWrapperProps {
  children: React.ReactNode;
  isFirst?: boolean;
}

/**
 * SectionWrapper - A reusable wrapper component for managing section spacing
 *
 * This component automatically handles spacing between sections by applying
 * negative margin to non-first sections to counteract FormSection's built-in margins.
 *
 * @param children - The content to wrap (typically a FormSection)
 * @param isFirst - Whether this is the first section (no negative margin applied)
 */
const SectionWrapper: React.FC<SectionWrapperProps> = ({
  children,
  isFirst = false
}) => {
  if (isFirst) {
    return <>{children}</>;
  }
  return <div className="-mt-4">{children}</div>;
};

export default SectionWrapper;
